import { cn } from '../../lib/cn'

interface StatBlockProps {
  label: string
  value: React.ReactNode
  /** Emphasise the value in moss (online / kindness). */
  positive?: boolean
  className?: string
}

/** Stat cell: Newsreader value over a mono label. */
export function StatBlock({ label, value, positive, className }: StatBlockProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <span className={cn('font-serif text-[24px] leading-none', positive ? 'text-moss' : 'text-ink')}>
        {value}
      </span>
      <span className="font-mono text-[10px] uppercase tracking-label text-ink-faint">{label}</span>
    </div>
  )
}
